import { useState, useEffect } from "react";
import BBIcon from "../Assets/BB-Icon.svg";
import BBPoster from "../Assets/BB-Poster.svg";
import TikTokIcon from "../Assets/TikTok-Icon.svg";
import Truck from "../Assets/Truck.png";
import Bagel from "../Assets/Bagel.png";
import WilliamWillson from "../Assets/WilliamWillson.jpg";
import KyleSouthall from "../Assets/KyleSouthall.jpg";

// Images to preload
const images = [
  BBIcon,
  BBPoster,
  TikTokIcon,
];

// Images to load in the background
const bgImages = [
  Truck,
  Bagel,
  WilliamWillson,
  KyleSouthall,
];

export function usePreloadImages() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let loadedCount = 0;
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          setLoaded(true);
        }
      };
      img.onerror = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          setLoaded(true);
        }
      };
    });
  }, []);

  useEffect(() => {
    bgImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return loaded;
}
